export const DEPOSIT_WARNING_TEXT =
  'Funds are credited after two blockchain network confirmations. Transfer rate depends on the commission set in your wallet.';
